import { render, staticRenderFns } from "./BaseLinkSave.vue?vue&type=template&id=514474d6&scoped=true&"
import script from "./BaseLinkSave.vue?vue&type=script&lang=js&"
export * from "./BaseLinkSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514474d6",
  null
  
)

export default component.exports